module.exports = __webpack_public_path__ + "img/mwiarda3.fdcc3846.jpg";